import { Injectable } from '@angular/core';

@Injectable()
export class RouteData {
  data: any;
}
